import CryptoJS from "crypto-js";

// Secret key untuk encryptStorage
const STORAGE_KEY = import.meta.env.VITE_STORAGE;

// Base URL API
export const URL_API = import.meta.env.VITE_URL_SSO;

/** Cek apakah variable kosong (undefined, null, atau string kosong) */
export const isEmpty = (variable) => [undefined, null, ""].includes(variable);

/** Encrypt string dengan AES + encodeURIComponent */
export function encryptData(value) {
  const encrypted = CryptoJS.AES.encrypt(value, STORAGE_KEY).toString();
  return encodeURIComponent(encrypted);
}

/** Decrypt string yang sudah di-encryptData */
export function decryptData(value) {
  try {
    const decodedValue = decodeURIComponent(value);
    const decrypted = CryptoJS.AES.decrypt(decodedValue, STORAGE_KEY).toString(
      CryptoJS.enc.Utf8
    );
    return decrypted || null;
  } catch (err) {
    console.error("Failed to decrypt data:", err);
    return null;
  }
}

/** Ambil pesan error pertama dari struktur FormError (string | array | object) */
export function getFirstErrorMessage(err) {
  if (!err) return null;

  // case string
  if (typeof err === "string") return err;

  // case array
  if (Array.isArray(err)) {
    const first = err[0];
    if (!first) return null;
    if (typeof first === "string") return first;
    return first?.value ?? null;
  }

  // case object
  return null;
}

export async function getCroppedImg(imageSrc, pixelCrop, size) {
  const image = new Image();
  image.src = imageSrc;
  await new Promise((r) => (image.onload = r));

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  // Kalau size dikirim, gunakan ukuran itu, kalau tidak pakai crop asli
  canvas.width = size?.width ?? pixelCrop.width;
  canvas.height = size?.height ?? pixelCrop.height;
  console.log(canvas.width, canvas.height);
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return canvas.toDataURL("image/jpeg");
}
